<mat-form-field class="default-field-width" [formGroup]="form" appearance="fill">
  <mat-label>{{ 'DROPDOWN.PLACEHOLDER' | translate }}</mat-label>
  <mat-select [formControlName]="controlName">
    <mat-option [value]="ComparisonType.ALL">{{ 'DROPDOWN.ALL_GROCERY' | translate }}</mat-option>
    <mat-option [value]="ComparisonType.BANNER">{{ 'DROPDOWN.SAME_BANNER' | translate }}</mat-option>
    <mat-option [value]="ComparisonType.FIT_CATEGORY">{{ 'DROPDOWN.SAME_FIT' | translate }}</mat-option>
  </mat-select>
</mat-form-field>
